export default __webpack_public_path__ + "static/media/AkzidenzGroteskBE-It.80faa15d.woff2";